import { SearchQueryRequestType } from '../../common/types';
import { usePostFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';
import { ReminderType } from '../recruitment-details/useGetRecruitmentReminders';

export type FetchRemindersResponseType = {
  count: number;
  results: ReminderType[];
};

export const useSearchReminders = (payload: SearchQueryRequestType) =>
  usePostFetch<FetchRemindersResponseType>(pathToUrl(ApiRoutesEnum.searchReminders), payload);
